module.exports = __webpack_public_path__ + "img/Platform-Varsom.cf5bc425.svg";